import { Union, Record } from "../fable_modules/fable-library-js.4.17.0/Types.js";
import { anonRecord_type, obj_type, union_type, record_type, option_type, string_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { unwrap, map, defaultArg, some } from "../fable_modules/fable-library-js.4.17.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { cons, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.17.0/List.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { createObj, uncurry2 } from "../fable_modules/fable-library-js.4.17.0/Util.js";
import { toString as toString_1, utcNow, op_Subtraction, parse, toUniversalTime } from "../fable_modules/fable-library-js.4.17.0/Date.js";
import { days } from "../fable_modules/fable-library-js.4.17.0/TimeSpan.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.17.0/String.js";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.2.7.0/React.fs.js";
import { Alert_snackError, LoadingIndicator_loadingIndicatorSmall, Checkbox_termsOfUse, TextField_TextField_textField } from "./Components.js";
import { empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.17.0/Seq.js";
import { Interop_reactApi } from "../fable_modules/Feliz.2.7.0/Interop.fs.js";

export class LoginResponse extends Record {
    constructor(Result, Message, BanUntil) {
        super();
        this.Result = Result;
        this.Message = Message;
        this.BanUntil = BanUntil;
    }
}

export function LoginResponse_$reflection() {
    return record_type("Aksjeio.OAuth.LoginResponse", [], LoginResponse, () => [["Result", string_type], ["Message", string_type], ["BanUntil", option_type(string_type)]]);
}

export class OAuthAuthResponse extends Record {
    constructor(Result, Email, Token) {
        super();
        this.Result = Result;
        this.Email = Email;
        this.Token = Token;
    }
}

export function OAuthAuthResponse_$reflection() {
    return record_type("Aksjeio.OAuth.OAuthAuthResponse", [], OAuthAuthResponse, () => [["Result", LoginResponse_$reflection()], ["Email", string_type], ["Token", string_type]]);
}

export class OAuthRegisterRequest extends Record {
    constructor(Token, Username) {
        super();
        this.Token = Token;
        this.Username = Username;
    }
}

export function OAuthRegisterRequest_$reflection() {
    return record_type("Aksjeio.OAuth.OAuthRegisterRequest", [], OAuthRegisterRequest, () => [["Token", string_type], ["Username", string_type]]);
}

export class AppleAuthRequest extends Record {
    constructor(Code, IdToken, Email) {
        super();
        this.Code = Code;
        this.IdToken = IdToken;
        this.Email = Email;
    }
}

export function AppleAuthRequest_$reflection() {
    return record_type("Aksjeio.OAuth.AppleAuthRequest", [], AppleAuthRequest, () => [["Code", string_type], ["IdToken", string_type], ["Email", option_type(string_type)]]);
}

class GenericResponse extends Record {
    constructor(Result, Message) {
        super();
        this.Result = Result;
        this.Message = Message;
    }
}

function GenericResponse_$reflection() {
    return record_type("Aksjeio.OAuth.GenericResponse", [], GenericResponse, () => [["Result", string_type], ["Message", string_type]]);
}

export class OAuthTarget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Google", "Apple"];
    }
}

export function OAuthTarget_$reflection() {
    return union_type("Aksjeio.OAuth.OAuthTarget", [], OAuthTarget, () => [[["Item", OAuthAuthResponse_$reflection()]], [["Item", OAuthAuthResponse_$reflection()]]]);
}

export class TokenResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StartRegister", "FailedAuth", "UserBanned"];
    }
}

export function TokenResult_$reflection() {
    return union_type("Aksjeio.OAuth.TokenResult", [], TokenResult, () => [[["Item", OAuthAuthResponse_$reflection()]], [["Item", string_type]], [["Item1", option_type(string_type)], ["Item2", string_type]]]);
}

export function handleAppleToken(callback, onComplete) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let matchValue, body, decoder, data_1, caseStrategy_3, extra_3;
        if (callback.error == null) {
            const req = new AppleAuthRequest(callback.authorization.code, callback.authorization.id_token, (matchValue = callback.user, (matchValue != null) ? matchValue.email : undefined));
            return ((body = Auto_generateBoxedEncoder_437914C6(AppleAuthRequest_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(OAuthAuthResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_3, extra_3)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/apple-auth/authenticate", properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(OAuthAuthResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })())))))).then((_arg_2) => {
                let matchValue_2, x_1, numDays, arg_1;
                const res = _arg_2;
                if (res.tag === 0) {
                    const r = res.fields[0];
                    switch (r.Result.Result) {
                        case "success": {
                            window.location.reload(true);
                            return Promise.resolve();
                        }
                        case "not-exist": {
                            onComplete(new TokenResult(0, [r]));
                            return Promise.resolve();
                        }
                        case "banned": {
                            onComplete(new TokenResult(2, [(matchValue_2 = r.Result.BanUntil, (matchValue_2 != null) ? ((x_1 = toUniversalTime(parse(matchValue_2)), (numDays = (days(op_Subtraction(x_1, utcNow())) | 0), (arg_1 = toString_1(x_1, "dd/MM/yyyy"), toText(printf("Til %s (%i dager igjen)"))(arg_1)(numDays))))) : undefined), r.Result.Message]));
                            return Promise.resolve();
                        }
                        default: {
                            onComplete(new TokenResult(1, [r.Result.Message]));
                            return Promise.resolve();
                        }
                    }
                }
                else {
                    onComplete(new TokenResult(1, ["Kunne ikke logge deg inn. Vennligst prøv igjen senere."]));
                    return Promise.resolve();
                }
            });
        }
        else {
            return Promise.resolve();
        }
    }));
    pr_1.then();
}

export function handleGoogleToken(x, onComplete) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let item, body, decoder, data_1, caseStrategy_3, extra_3;
        return ((item = {
            Token: x,
        }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Token", string_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(OAuthAuthResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_3, extra_3)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/google-auth/authenticate", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(OAuthAuthResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))))).then((_arg_2) => {
            let matchValue_1, x_2, numDays, arg_1;
            const res = _arg_2;
            if (res.tag === 0) {
                const r = res.fields[0];
                switch (r.Result.Result) {
                    case "success": {
                        window.location.reload(true);
                        return Promise.resolve();
                    }
                    case "not-exist": {
                        onComplete(new TokenResult(0, [r]));
                        return Promise.resolve();
                    }
                    case "banned": {
                        onComplete(new TokenResult(2, [(matchValue_1 = r.Result.BanUntil, (matchValue_1 != null) ? ((x_2 = toUniversalTime(parse(matchValue_1)), (numDays = (days(op_Subtraction(x_2, utcNow())) | 0), (arg_1 = toString_1(x_2, "dd/MM/yyyy"), toText(printf("Til %s (%i dager igjen)"))(arg_1)(numDays))))) : undefined), r.Result.Message]));
                        return Promise.resolve();
                    }
                    default: {
                        onComplete(new TokenResult(1, [r.Result.Message]));
                        return Promise.resolve();
                    }
                }
            }
            else {
                onComplete(new TokenResult(1, ["Kunne ikke logge deg inn. Vennligst prøv igjen senere."]));
                return Promise.resolve();
            }
        });
    }));
    pr_1.then();
}

export function OAuthRegister(oAuthRegisterInputProps) {
    let elems_2, elems_1;
    const target = oAuthRegisterInputProps.target;
    const patternInput = useFeliz_React__React_useState_Static_1505("");
    const username = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(true);
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(false);
    const setProcessing = patternInput_2[1];
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(undefined);
    const setErrMsg = patternInput_3[1];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(false);
    const terms = patternInput_4[0];
    const title = (target.tag === 1) ? "Apple" : "Google";
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        maxWidth: 515,
        gap: ((20 + "px ") + 0) + "px",
        padding: 10,
    }], (elems_2 = [createElement("h1", {
        style: {
            fontSize: 2 + "rem",
            color: "var(--text-main)",
            fontWeight: "bold",
        },
        children: `Registrer deg med ${title}-konto`,
    }), createElement("p", {
        style: {
            marginBottom: 0,
        },
        children: `Denne ${title}-kontoen og e-post adressen er ikke registrert på én eksisterende aksje.io bruker. Fyll inn et brukernavn i feltet under for å komme i gang.`,
    }), TextField_TextField_textField(username, (u) => {
        const trimmed_1 = u.trim();
        patternInput[1](trimmed_1);
        patternInput_1[1](trimmed_1.length > 0);
    }, ofArray([["autoComplete", "username"], ["autoFocus", true], ["placeholder", "Brukernavn"], ["style", createObj(toList(delay(() => (!patternInput_1[0] ? singleton_1(["border", (((2 + "px ") + "solid") + " ") + "red"]) : empty_1()))))]])), createElement("span", {
        children: ["Kun brukernavnet er synlig for andre brukere på aksje.io."],
    }), TextField_TextField_textField((target.tag === 1) ? target.fields[0].Email : target.fields[0].Email, (_arg_3) => {
    }, ofArray([["type", "email"], ["disabled", true], ["style", {
        fontStyle: "italic",
        color: "var(--text-dim)",
    }]])), Checkbox_termsOfUse(terms, patternInput_4[1]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        minHeight: 40,
    }], (elems_1 = toList(delay(() => {
        let elems;
        return terms ? singleton_1(createElement("button", createObj(ofArray([["type", "submit"], ["className", "pill-button"], ["style", {
            width: 250,
        }], ["onClick", (e) => {
            e.preventDefault();
            const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let body, decoder, data_1, caseStrategy_3, extra_3;
                const trimmed = username.trim();
                if (!((trimmed.length >= 3) && (trimmed.length <= 16))) {
                    setErrMsg("Brukernavnet må være mellom 3 og 16 tegn");
                    return Promise.resolve();
                }
                else {
                    setErrMsg(undefined);
                    setProcessing(true);
                    const req = new OAuthRegisterRequest((target.tag === 1) ? target.fields[0].Token : target.fields[0].Token, trimmed);
                    const requestPath = (target.tag === 1) ? "/api/apple-auth/register" : "/api/google-auth/register";
                    return ((body = Auto_generateBoxedEncoder_437914C6(OAuthRegisterRequest_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_3, extra_3)(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                    let matchValue;
                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })())))))).then((_arg_2) => {
                        const res = _arg_2;
                        if (res.tag === 0) {
                            const x_1 = res.fields[0];
                            if (x_1.Result === "success") {
                                window.location.reload(true);
                                return Promise.resolve();
                            }
                            else {
                                setErrMsg(x_1.Message);
                                setProcessing(false);
                                return Promise.resolve();
                            }
                        }
                        else {
                            setErrMsg("Kunne ikke registrere bruker. Vennligst prøv igjen senere");
                            setProcessing(false);
                            return Promise.resolve();
                        }
                    });
                }
            }));
            pr_1.then();
        }], (elems = toList(delay(() => (patternInput_2[0] ? singleton_1(LoadingIndicator_loadingIndicatorSmall()) : singleton_1("Registrer deg")))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : empty_1();
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), Alert_snackError(patternInput_3[0], () => {
        setErrMsg(undefined);
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
}

